<template>
    <div class="client-logo-slider" v-if="brands.length">
        <!-- <splide :slides="brands" :options="options">
            <splide-slide v-for="slide in brands" :key="slide.image_name">
                <img :src="filePath+'/'+slide.image_name" :alt="slide.brand">
            </splide-slide>
        </splide> -->
        <!-- <carousel 
            :autoplay="true" 
            :nav="false" 
            :loop="true" 
            :rewind="true"
            :margin="15"
            :responsive="{0:{items:2,nav:false},600:{items:3,nav:true},641:{items:3,nav:true},1024:{items:4,nav:true},1500:{items:5}}"
            >
             <img src="https://placeimg.com/200/200/any?1">

            <img src="https://placeimg.com/200/200/any?2">

            <img src="https://placeimg.com/200/200/any?3">

            <img src="https://placeimg.com/200/200/any?4">
        </carousel> -->
        <VueSlickCarousel v-bind="settings">
            <div v-for="slide in brands" :key="slide.image_name">
                <img :src="filePath+'/'+slide.image_name" :alt="slide.brand">
            </div>
        </VueSlickCarousel>
        <!-- <vueper-slides
            class="no-shadow"
            :visible-slides="3"
            slide-multiple
            :gap="3"
            :slide-ratio="1 / 4"
            :dragging-distance="200"
            fixedHeight="80px"
            :breakpoints="{ 800: { visibleSlides: 2, slideMultiple: 2 } }">
            <vueper-slide v-for="slide in brands" :key="slide.image_name" :image="filePath+'/'+slide.image_name" />
        </vueper-slides> -->
    </div>    
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
// optional style for arrows & dots
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

export default {
    components: { 
        VueSlickCarousel 
    },
    data() {
        return {
            items: 5,
            autoplay: true,
            nav: false,
            margin: 15,
            responsive: {0:{items:1,nav:false},600:{items:1,nav:true},641:{items:2,nav:true},1024:{items:3,nav:true},1500:{items:4}},
            brands: [],
            filePath: '',  
            settings: {
                "arrows": false,
                "dots": false,
                "infinite": true,
                "slidesToShow": 4,
                "slidesToScroll": 1,
                "autoplay": true,
                "speed": 2000,
                "autoplaySpeed": 2000,
                "cssEase": "linear",
                "responsive": [
                    {
                        "breakpoint": 1024,
                        "settings": {
                            "slidesToShow": 3,
                            "slidesToScroll": 3,
                            "infinite": true,
                            "dots": true
                        }
                    },
                    {
                        "breakpoint": 600,
                        "settings": {
                            "slidesToShow": 2,
                            "slidesToScroll": 2,
                            "initialSlide": 2
                        }
                    },
                    {
                        "breakpoint": 480,
                        "settings": {
                            "slidesToShow": 2,
                            "slidesToScroll": 2,
                            "variableWidth": true,
                        }
                    }
                ]

            }         
        }
    },
    methods: {
        async getData(){            
            this.$http.get(`/brands`).then(res=>{         
                if(res.status === 200 && res.data.result){
                    this.brands = res.data.result
                    this.filePath = res.data.file_path
                }
            })
        }
    },
    created: function(){
        this.getData()
    }
}
</script>

<style scoped>

</style>